import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { InspectionItemModal } from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-inspection-tab/InspectionItemModal';
import { BoxForm, FormControlDefault, MenuItemStyled, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { InspectionTypes } from 'app/shared/model/enumerations/inspection-types.model';
import { extractIds } from 'app/shared/util/functions-util';
import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { createEntity, getEntity, reset, updateEntity } from './inspection.reducer';

export const InspectionUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const inspectionType: InspectionTypes[] = [InspectionTypes.DAILY, InspectionTypes.MAINTENANCE];

  const inspectionEntity = useAppSelector(state => state.inspection.entity);
  const loading = useAppSelector(state => state.inspection.loading);
  const updateSuccess = useAppSelector(state => state.inspection.updateSuccess);
  const [selectedInspectionItem, setSelectedInspectionItem] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    type: '',
  });

  const handleClose = () => {
    props.history.push('/inspection' + props.location.search);
  };

  useEffect(() => {
    if (!isNew) {
      setSelectedInspectionItem(inspectionEntity?.inspectionItems);
    }
  }, [inspectionEntity, isNew]);

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, [isNew]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (!loading && !isNew) {
      setFormData({
        name: inspectionEntity.name,
        description: inspectionEntity.description,
        type: inspectionEntity.type,
      });
    }
  }, [loading, isNew, inspectionEntity]);

  const saveEntity = values => {
    const entity = {
      ...inspectionEntity,
      ...values,
      inspectionItems: extractIds(selectedInspectionItem),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleSubmit = event => {
    event.preventDefault();
    saveEntity(formData);
  };

  const getSelectedInspectionItemsMessage = () => {
    return selectedInspectionItem && selectedInspectionItem.length
      ? `${selectedInspectionItem.length} ${selectedInspectionItem.length > 1 ? 'itens de inspeção selecionados' : 'item de inspeção selecionado'}`
      : '';
  };

  return (
    <ThemeProvider theme={theme}>
      <RegisterLayout>
        <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
          <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.inspectionItem'} />
          <Box>
            {loading ? (
              <Box>
                <Typography>Loading...</Typography>
              </Box>
            ) : (
              <Box margin={'0 auto'} width={'100%'}>
                <BoxForm onSubmit={handleSubmit}>
                  {!isNew && (
                    <FormControlDefault sx={{ display: 'none' }}>
                      <TypographyForms>{translate('global.field.id')}</TypographyForms>
                      <TextFieldForms value={formData['id']} id={'inspection-id'} name={'id'} />
                    </FormControlDefault>
                  )}

                  <FormControlDefault variant={'outlined'}>
                    <TypographyForms>{translate('fleetSenseApp.inspection.name')}</TypographyForms>
                    <TextFieldForms
                      value={formData['name']}
                      id={'inspection-name'}
                      data-cy={'name'}
                      name={'name'}
                      required={true}
                      onChange={e => handleInputChange('name', e.target.value)}
                    />
                  </FormControlDefault>
                  <FormControlDefault variant={'outlined'}>
                    <TypographyForms>{translate('fleetSenseApp.inspection.description')}</TypographyForms>
                    <TextFieldForms
                      value={formData['description']}
                      id={'fleetSenseApp.inspection-description'}
                      data-cy={'description'}
                      name={'description'}
                      required={true}
                      onChange={e => handleInputChange('description', e.target.value)}
                    />
                  </FormControlDefault>
                  <FormControlDefault>
                    <TypographyForms>{translate('fleetSenseApp.inspection.type')}</TypographyForms>
                    <TextFieldForms
                      value={formData['type'] || ''}
                      onChange={event => handleInputChange('type', event.target.value)}
                      select
                      name={'type'}
                      id={'inspection-type'}
                      data-cy={'type'}
                      required={true}
                    >
                      {inspectionType.map(type => (
                        <MenuItemStyled value={type} key={type}>
                          {translate(`fleetSenseApp.InspectionTypes.${type}`)}
                        </MenuItemStyled>
                      ))}
                    </TextFieldForms>
                  </FormControlDefault>
                  {formData.type === InspectionTypes.DAILY && (
                    <FormControlDefault>
                      <TypographyForms>{translate('fleetSenseApp.inspection.inspectionItem')}</TypographyForms>
                      <TextFieldForms
                        required
                        sx={{ cursor: 'pointer !important' }}
                        id="inspection-inspectionItem"
                        name="inspectionItems"
                        onClick={() => setModalOpen(true)}
                        value={getSelectedInspectionItemsMessage()}
                        placeholder={translate('fleetSenseApp.inspection.inspectionItemPlaceholder')}
                      />
                    </FormControlDefault>
                  )}
                  {modalOpen && (
                    <InspectionItemModal
                      setModalOpen={setModalOpen}
                      selectedInspectionItems={selectedInspectionItem}
                      setSelectedInspectionItems={setSelectedInspectionItem}
                    />
                  )}
                  <RegisterButton disabled={false} />
                </BoxForm>
              </Box>
            )}
          </Box>
        </Box>
      </RegisterLayout>
    </ThemeProvider>
  );
};

export default InspectionUpdate;
